import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='merchantName' subtitle='String' label='Deprecated' mdxType="Item">
      <p>{`Set it to the merchant name that you want to be shown on the Apple Pay screen. Deprecated, use `}<a parentName="p" {...{
          "href": "https://primer.io/docs/api/api-reference/client-session-api/create-client-side-token#response.body.paymentMethod.options.%3CPAYMENT_METHOD_TYPE%3E.merchantName"
        }}>{`ClientSession`}</a>{` instead.`}</p>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      